import { AutoMap } from "@automapper/classes";

export class LimitCategory {
    public constructor(init?: Partial<LimitCategory>) {
        Object.assign(this, init);
    }
    @AutoMap()
    Code: string = ''
    @AutoMap()
    Name: string = '';
    @AutoMap()
    IsActive: boolean = false;
    @AutoMap()
    ForeColor: string = '';
    @AutoMap()
    BackColor: string = '';
    @AutoMap()
    OutOfLimitForeColor: string = '';
    @AutoMap()
    OutOfLimitBackColor: string = '';

}